/** Hugging Face 集成 API；Token 仅提交，响应只包含掩码凭据。 */
import type {
  HuggingFaceCredentialResponse,
  UpsertHuggingFaceCredentialRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const huggingFaceApi = {
  getCredential: () =>
    apiRequest<HuggingFaceCredentialResponse>({
      method: 'GET',
      path: '/api/v1/integrations/huggingface/credential',
    }),
  upsertCredential: (body: UpsertHuggingFaceCredentialRequest) =>
    apiRequest<HuggingFaceCredentialResponse>({
      method: 'PUT',
      path: '/api/v1/integrations/huggingface/credential',
      body,
    }),
  removeCredential: () =>
    apiRequest<{ removed: true }>({
      method: 'DELETE',
      path: '/api/v1/integrations/huggingface/credential',
    }),
  testConnection: () =>
    apiRequest<{ connected: true }>({
      method: 'POST',
      path: '/api/v1/integrations/huggingface/credential/test',
    }),
};
